import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import CourseChapter from "../../Courses/CourseDetails/CourseChapterDetails/CourseChapter";
import { connect } from "react-redux";
import "../../Courses/CourseDetails/CourseChapterDetails/accordion.css";
import { Link, useHistory } from "react-router-dom";
import CourseTile from "../../Courses/CourseTile/CourseTile";
import CoursePercentage from "../../Courses/CourseDetails/CourseProgress";
import { courseIncludes, loremData } from "../../../_constants/staticData";
import axios from "../../../axios";
import Instructor from "../../Courses/CourseDetails/CourseChapterDetails/instructor";
import Button from "../../Other/element/Button";
import QuizTest from "../../Courses/CourseDetails/CourseChapterDetails/quizTest";
// import QuizTest from "./CourseChapterDetails/quizTest";

const ChapterOverView = (props) => {
  const history = useHistory();
  const { t } = useTranslation();
  const [hide, setHide] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [showMoreHighlight, setShowMoreHighlight] = useState(false);
  const [showMoreSyllabus, setShowMoreSyllabus] = useState(false);
  const [showMoreFaqs, setShowMoreFaqs] = useState(false);
  const [stats, setStats] = useState(props.course.courseSections);
  const [showMoreDescription, setShowMoreDescription] = useState(false);
  const [showMoreCourseOutDescription, setshowMoreCourseOutDescription] =
    useState(false);

  const numberOfItems = showMore ? props?.course?.goals?.length : 2;
  const numberOfHighlight = showMoreHighlight
    ? props?.course?.preRequisites?.length
    : 2;
  const numberOfSyllabus = showMoreSyllabus
    ? props?.course?.syllabus?.length
    : 2;
  const numberOfFaqs = showMoreFaqs ? props?.course?.faqs?.length : 2;

  const showProgress = stats?.some((item) => item.isFinished);

  const handleExpand = () => {
    setShowMore(!showMore);
  };

  const handleHighlightExpand = () => {
    setShowMoreHighlight(!showMoreHighlight);
  };

  const handleSyllabusExpand = () => {
    setShowMoreSyllabus(!showMoreSyllabus);
  };

  const handleFaqsExpand = () => {
    setShowMoreFaqs(!showMoreFaqs);
  };
  const TimeConversion = (value) => {
    value = Number(value);
    var hour = Math.floor(value / 3600);
    var min = Math.floor((value % 3600) / 60);
    var second = Math.floor((value % 3600) % 60);

    var hourValue = hour > 0 ? hour + (hour == 1 ? " hour " : " hours") : "";
    var minValue = min > 0 ? min + (min == 1 ? " min " : " mins") : "";
    var secondValue =
      second > 0 ? second + (second == 1 ? "second" : "seconds") : "";

    if (hourValue) {
      return hourValue + " " + minValue;
    } else if (minValue) {
      return minValue;
    } else return secondValue;
  };

  const updateChapterData = (id, isFinished) => {
    const currentData = stats.map((ele) => {
      if (ele.id === id) {
        return { ...ele, isFinished: isFinished };
      }
      return ele;
    });

    setStats(currentData);
  };

  const ProgressData = (courseId) => {
    axios
      .get(`course/${courseId}`)
      .then((response) => {
        setStats(response.data.data.recordset[0].courseSections);
      })
      .catch((error) => console.log(error));
  };

  const handleDescriptionMore = () => {
    setShowMoreDescription(!showMoreDescription);
  };

  const handleCourseOutDescription = () => {
    setshowMoreCourseOutDescription(!showMoreCourseOutDescription);
  };

  const instructorQuery = () => {
    setHide(!hide);
  };

  return (
    <>
      <div className="inner-div">
        <div className="main-cart-course">
          <div className="course-cart-left">
            {props.course?.goals?.length > 0 && (
              <div>
                <div className="section-title">{t("Course Highlights")}</div>

                <ul>
                  {props?.course?.goals
                    .slice(0, numberOfItems)
                    .map((course, index) => {
                      return <li key={index}>{course.name}</li>;
                    })}
                </ul>
                {props?.course?.goals?.length > 2 && (
                  <div className="expand-readmore" onClick={handleExpand}>
                    <span> {showMore ? "- Read less" : "+ Read more"}</span>
                  </div>
                )}
              </div>
            )}
            {props.course?.preRequisites?.length > 0 && (
              <div className="course-page-section">
                <div className="section-title">{t("Course Requirements")}</div>
                <ul>
                  {props?.course?.preRequisites
                    .slice(0, numberOfHighlight)
                    .map((course, index) => {
                      return <li key={index}>{course.name}</li>;
                    })}
                </ul>
                {props?.course?.preRequisites?.length > 2 && (
                  <div
                    className="expand-readmore"
                    onClick={handleHighlightExpand}
                  >
                    <span>
                      {showMoreHighlight ? "- Read less" : "+ Read more"}
                    </span>
                  </div>
                )}
              </div>
            )}
            {props?.loggedIn && props.course?.courseSections?.length > 0 && (
              <div>
                <div className="section-title">{t("Course Content")}</div>
                <div className="pro-bar-width">
                  {props.course.isPurchased && showProgress && (
                    <CoursePercentage course={stats} />
                  )}
                </div>
                {props.course.courseSections ? (
                  <>
                    <div className="accordion chapterMapped">
                      {props.course.courseSections.map((course, index) => (
                        <div key={index}>
                          <CourseChapter
                            index={index}
                            title={course.sectionName}
                            content={course.sectionDescription}
                            view={course.files}
                            scroms={course?.scroms}
                            acknowledge={course.isFinished}
                            status={props.course.isPurchased}
                            TimeConversion={TimeConversion}
                            ID={props?.course?.ID}
                            sectionId={course.id}
                            updateChapterData={updateChapterData}
                            fetchData={ProgressData}
                            videoLink={course.videoLink}
                          />
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="enroll-courseinto">
                      <Link className="btn next">
                        {t("Enroll for this course")}
                      </Link>
                    </div>
                  </>
                )}
              </div>
            )}
            {props.course.courseSections && (
              <QuizTest
                courseId={props?.course?.ID}
                isPurchased={props?.course?.isPurchased}
              />
            )}
            <div className="course-page-section">
              {props.course.Description && (
                <>
                  <div className="section-title">{t("Course Description")}</div>
                  <div>
                    <p
                      dangerouslySetInnerHTML={
                        props?.course?.Description.length > 180
                          ? showMoreDescription
                            ? {
                                __html: props?.course?.Description,
                              }
                            : {
                                __html:
                                  props?.course?.Description.substring(
                                    0,
                                    3000
                                  ) + "...",
                              }
                          : {
                              __html: props?.course?.Description,
                            }
                      }
                    ></p>
                    {props?.course?.Description.length > 3000 && (
                      <p
                        className="expand-readmore"
                        onClick={handleDescriptionMore}
                      >
                        {showMoreDescription ? " - Read less" : "+ Read more"}
                      </p>
                    )}
                  </div>
                </>
              )}
            </div>
            {props.course.isPurchased && (
              <div className="course-page-section">
                {props.course.courseOutDescription && (
                  <>
                    <div className="section-title">
                      {t("Course Inner Description")}
                    </div>
                    <div>
                      <p
                        dangerouslySetInnerHTML={
                          showMoreCourseOutDescription
                            ? {
                                __html: props?.course?.courseOutDescription,
                              }
                            : {
                                __html:
                                  props?.course?.courseOutDescription.substring(
                                    0,
                                    3000
                                  ) + "...",
                              }
                        }
                      ></p>
                      {props?.course?.courseOutDescription.length > 3000 && (
                        <p
                          className="expand-readmore"
                          onClick={handleCourseOutDescription}
                        >
                          {showMoreCourseOutDescription
                            ? " - Read less"
                            : "+ Read more"}
                        </p>
                      )}
                    </div>
                  </>
                )}
              </div>
            )}

            {props.course && props.course?.faqs?.length > 0 && (
              <>
                <div className="course-page-section">
                  <div className="section-title">{t("Course FAQs")}</div>
                  {props.course &&
                    props.course.faqs
                      .slice(0, numberOfFaqs)
                      .map((course, index) => (
                        <div key={index} className="section-para">
                          <h4>
                            {index + 1}. {course.question}
                          </h4>
                          <p>{course.answer}</p>
                        </div>
                      ))}
                </div>
                {props.course.faqs.length > 2 && (
                  <div className="expand-readmore" onClick={handleFaqsExpand}>
                    <span> {showMoreFaqs ? "- Read less" : "+ Read more"}</span>
                  </div>
                )}
              </>
            )}
            {props.course && props.course?.syllabus?.length > 0 && (
              <div className="course-page-section">
                <div className="section-title">{t("Course Syllabus")}</div>
                <ul>
                  {props?.course?.syllabus
                    .slice(0, numberOfSyllabus)
                    .map((course, index) => {
                      return <li key={index}>{course.name}</li>;
                    })}
                </ul>
                {props.course.syllabus.length > 2 && (
                  <div
                    className="expand-readmore"
                    onClick={handleSyllabusExpand}
                  >
                    <span>
                      {showMoreSyllabus ? "- Read less" : "+ Read more"}
                    </span>
                  </div>
                )}
              </div>
            )}
            {props.course.relatedCourses.length > 0 && (
              <div className="related-course">
                <div className="front-panel">
                  <div className="courseList">
                    <div className="section-title">{t("Related Courses")}</div>
                    <div className="tile-column">
                      {props.course.relatedCourses.map((post, index) => (
                        <CourseTile key={index} post={post} />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="course-cart-right">
            <div className="edged-wrapper">
              <div className="right-side-header">{t("Includes")}</div>
              <div className="right-sider-icons-div">
                <ul>
                  {props?.course?.duration !== 0 && (
                    <li>
                      <span>
                        {TimeConversion(props.course.duration)} of video
                        material
                      </span>
                    </li>
                  )}
                  <li>
                    <span>
                      {courseIncludes.key1} : {props.course.Language}
                    </span>
                  </li>
                  <li>
                    <span> {courseIncludes.key2}</span>
                  </li>
                  <li>
                    <span> {courseIncludes.key3}</span>
                  </li>
                  <li>
                    <span> {courseIncludes.key4}</span>
                  </li>
                  <li>
                    <span> {courseIncludes.key5}</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="right-question-btn">
              {props.course.isPurchased && (
                <Button
                  handleClick={() => setHide(!hide)}
                  title="Questions for the Instructor?"
                  className=""
                />
              )}
            </div>

            {/* <div className="edged-wrapper">
              <div className="right-side-header">INSTRUCTOR Q&amp;A</div>

              <div className="right-question">
                <p>Question. {loremData.key1}</p>
                <p>Answer. {loremData.key1}</p>
              </div>

              <div className="right-question">
                <p>Question. {loremData.key1}</p>
                <p>Answer.{loremData.key1}</p>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {hide && <Instructor instructorQuery={instructorQuery} />}
    </>
  );
};

function mapStateToProps(state) {
  const { loggedIn } = state.authentication;
  return {
    loggedIn,
  };
}

const connectedChapterOverView = connect(mapStateToProps)(ChapterOverView);
export default connectedChapterOverView;
